module.exports = __webpack_public_path__ + "assets/row.88cc2b15.svg";